import React from 'react'
import theme from '../../theme'
import PropTypes from 'prop-types'

// application component
import Aux from '../../hoc/Ax/Ax'
import SideBarItem from '../../components/Sidebar/SidebarItem/SidebarItem'

// material zui
import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'
import {t} from 'i18next'

const styles = {
    root: {
        whiteSpace: 'pre-wrap',
        padding: '0 16px 21.5px 27px',
        marginTop: '-10px',
        paddingLeft: theme.spacing.unit * 2,
        width: theme.dimensions.SidebarWidth,
        //minWidth:300,
        zIndex:5000,
        
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing.unit * 2,
        },
        [theme.breakpoints.down('xs')]: {
            padding: '15px 16px 21.5px 27px',
        },
    },
    myStyle: {
        whiteSpace: 'pre-wrap',
        padding: '5px 5px 5px 5px',
        paddingLeft: theme.spacing.unit * 2,
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing.unit * 2,
        },
        [theme.breakpoints.down('xs')]: {
            padding: '5px 5px 5px 5px',
        },
    },
    button: {
        fill: theme.palette.primary.main,
    },
    iconButton: {
        position: 'relative',
        left: '-10px',
    },
   
}

/**
 * component for sidebar
 * @param classes
 * @param handleAccountDeletion
 * @returns {*}
 */
const accountAdministration = ({ classes,  handleAccountDeletion }) => (
    
    <Aux>
        <div>
        <SideBarItem
            title={t('User.heading_account_administration_delete')}
            subtitle={t('User.sub_heading_account_administration_delete')}
        >
            <IconButton style={styles.iconButton} onClick={event => handleAccountDeletion(event)}>
                <DeleteIcon style={styles.button}/>
            </IconButton>
        </SideBarItem>
        </div>
    </Aux>
    
)

accountAdministration.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    handleAccountDeletion: PropTypes.func.isRequired,
}

export default accountAdministration
